import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';

import {ActivatedRoute} from "@angular/router";
import {Produto} from "../../../../server/domain/Produto";
import {ProdutoService} from "../../services/produto.service";
import {NgForm} from "@angular/forms";
import {EditEvent, PageChangeEvent, RemoveEvent} from "@progress/kendo-angular-grid";
import {CadAdicionalProdutoComponent} from "../cad-adicional-produto/cad-adicional-produto.component";
import {ProdutoPizza} from "../../../../server/domain/ProdutoPizza";
import {ProdutoTamanho} from "../../../../server/domain/templates/ProdutoTamanho";
import {AdicionalDeProdutoEscolhaSimples} from "../../../../server/domain/delivery/AdicionalDeProdutoEscolhaSimples";
import {OpcaoDeAdicionalDeProduto} from "../../../../server/domain/delivery/OpcaoDeAdicionalDeProduto";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {ViewDisponibilidadeComponent} from "../../compartilhado/view-disponibilidade/view-disponibilidade.component";
import {TabStripComponent} from "@progress/kendo-angular-layout";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {ModalKendo} from "../../lib/ModalKendo";
import {FiscalService} from "../../fidelidade/fiscal/services/fiscal.service";
import {AssociarInsumoComponent} from "./associar-insumo/associar-insumo.component";
import {CuponsService} from "../services/cupons.service";
import {ComissionamentoService} from "../../services/comissionamento.service";
import {CanaisVendaFacade} from '../../canais-venda/canais-venda.facade';


@Component({
  selector: 'app-cad-produto',
  templateUrl: './cad-produto.component.html',
  styleUrls: ['./cad-produto.component.scss'],
  providers: [CanaisVendaFacade]
})
export class CadProdutoComponent extends ModalKendo implements OnInit, OnDestroy {
  static DISPONIBILIDADES  = [
    { id: 0, descricao: 'Sempre', disponivel: true},
    { id: 1, descricao: 'Dias e horarios específicos', disponivel: true},
    { id: 2, descricao: 'Indisponível', disponivel: false}];


  @ViewChild('cadAdicionalProduto',  { static: false}) cadAdicionalProduto: CadAdicionalProdutoComponent;
  @ViewChild('frm',  { static: false} ) frm: NgForm;
  @ViewChild('viewDisponibilidades',  { static: false} ) viewDisponibilidades: ViewDisponibilidadeComponent;
  @ViewChild('frmf',  { static: false} ) frmf: NgForm;
  @ViewChild('tabSet') tabSet: TabStripComponent;
  @ViewChild('telaInsumoAssociado') telaInsumoAssociado: AssociarInsumoComponent;
  catalogo: any;
  empresa: any;

  templatesPiza: any = [];
  mensagemSucesso: any;
  mensagemErro: any;
  produto: any = new Produto();
  carregando: boolean;
  abrirDialogAdicional: boolean;
  abraDialogoRemover: boolean;
  adicionalRemover: any;
  adicionalRemoverIndex: number;
  novo: boolean;
  copiarAdicional: boolean;
  tiposDeVenda: any  = ['Unidade', 'Peso'];
  unidades  = [  ];
  disponibilidades  = CadProdutoComponent.DISPONIBILIDADES;
  tipoDeProduto: any ;
  TIPOSDEPRODUTOS = {
    Normal: 'normal',
    Pizza: 'pizza',
    BrindeFidelidade: 'brindefidelidade'
  }
  adicionalMassa: any = {}
  adicionalBorda: any =  {}
  salvando: boolean;
  exibirDescontos: boolean;
  categorias: []
  cupons:  any =  []
  carregandoProduto: boolean;
  salvouProduto: boolean
  usuarioLogado: any;
  temModuloFidelidade: boolean
  temModuloPedidos: boolean
  temModuloFiscal: boolean
  podeEditarProdutos: boolean;
  classificacao: any = {}
  origens: any;

  mapTabsPorId: any = {
    'detalhes': 0,
    'adicionais': 1,
    'disponibilidade': 2,
    'historico': 3,
  }
  modoAdminRede: boolean;
  podeEditarPrecos: boolean;
  tabelaPrecosTargetKey: string | null = null;
  abrirTabelaPrecosAoCarregar = false;
  modoProdutosExternos = false;
  tagsAlimentar = [];
  salvou: boolean;
  tiposDeTributacaoIPI: any = [];
  selosDeControleIPI: any = [];
  tipoDeAcumulo: any = 'Pontos';
  ncmOptions: any[] = [];
  ncmSelecionado: any = null;
  ncmLoading = false;
  cestOptions: any[] = [];
  cestSelecionado: any = null;
  cestLoading = false;
  dadosFiscaisCarregados = false;
  carregandoDadosFiscais = false;
  private ncmSearchTimer: any = null;
  private cestSearchTimer: any = null;
  temModuloTabelaPrecos = false;
  exibirPrecosCanais = false;
  private ultimoProdutoIdPrecosCanais: number | null = null;

  get exibirTabelaPrecosSeparada(): boolean {
    return this.temModuloTabelaPrecos;
  }
  temModuloComissionamento = false;
  comissoes: any[] = [];
  salvandoComissaoProduto = false;

  get podeBuscarCestFiscal(): boolean {
    return /^\d{8}$/.test(this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm));
  }

  constructor( private route: ActivatedRoute, private constantsService: ConstantsService,
              private cuponsService: CuponsService,
              public produtoService: ProdutoService, private autorizacaoService: AutorizacaoService,
              private fiscalService: FiscalService,
              private comissionamentoService: ComissionamentoService,
              private canaisVendaFacade: CanaisVendaFacade
              ) {
    super()
    this.produtoService.listeUnidades().then( (unidades: any) => {
      this.unidades = unidades;
      this.setUnidadeProduto();
    });
  }

  ngOnInit() {
      if(!this.produto.id)
        this.setProduto( this.produto)
      else
        this.tipoDeProduto = this.produto.tipo;

      if( this.tipoDeProduto === this.TIPOSDEPRODUTOS.Pizza )
        this.atualizeMapTabsPorId();

    this.constantsService.moduloFidelidade$.subscribe( data => this.temModuloFidelidade  = data  )
    this.constantsService.moduloPedido$.subscribe( data => this.temModuloPedidos  = data);
    this.constantsService.moduloTabelaPrecos$.subscribe((ativo) => {
      this.temModuloTabelaPrecos = !!ativo;
      this.atualizeMapTabsPorId();
      this.selecioneTabelaPrecosInicialSeSolicitado();
    });
    this.constantsService.moduloComissionamento$.subscribe((ativo) => {
      this.temModuloComissionamento = !!ativo;
      this.atualizeMapTabsPorId();
      if(this.temModuloComissionamento)
        this.carregueComissoes();
    });
    this.categorias = this.catalogo.categorias;
    this.podeEditarProdutos = !this.empresa || !this.empresa.id || !this.catalogo || !this.catalogo.compartilhado

    this.constantsService.moduloFiscal$.subscribe( data => {
      this.temModuloFiscal  = data

      if(this.temModuloFiscal) {
        if(!this.produto.configuracaoFiscal)
          this.produto.configuracaoFiscal = {}

      }
    });





      this.modoAdminRede = !this.empresa || !this.empresa.id;
      this.podeEditarPrecos = this.podeEditarProdutos || (this.catalogo && this.catalogo.precoPorEmpresa
        && RotaGuardClient.alterarPrecoCardapioCompartilhado(this.autorizacaoService.getUser()));

      this.usuarioLogado = this.autorizacaoService.getUser();
      this.atualizeMapTabsPorId();
      this.carregueVisibilidadePrecosCanais();


  }

  ngOnDestroy() {
    if(this.ncmSearchTimer) {
      clearTimeout(this.ncmSearchTimer);
      this.ncmSearchTimer = null;
    }
    if(this.cestSearchTimer) {
      clearTimeout(this.cestSearchTimer);
      this.cestSearchTimer = null;
    }
  }

  carregueProduto(produtoIncompleto: Produto) {
    this.carregandoProduto = true;
    this.produtoService.obtenhaProduto(produtoIncompleto.id, this.catalogo, this.empresa).then( (produto) => {
      this.carregandoProduto = false;

      this.setProduto(produto);
    }).catch( (erro) => {
      this.carregandoProduto = false;
    });
  }

  setUnidadeProduto(){
    if(this.produto.unidadeMedida){
      this.produto.unidadeMedida = this.unidades.find( unidade => unidade.id === this.produto.unidadeMedida.id );
      this.setValoresPadroes();
    }

  }

  setProduto(produto: Produto){
    this.produto = produto;
    console.log(this.produto);
    if(this.produto.categoria)
      this.produto.categoria = this.catalogo.categorias.find( categoria => categoria.id === this.produto.categoria.id);

    if(!this.produto.tipoDeVenda)
      this.produto.tipoDeVenda =  this.tiposDeVenda[0];

    if(this.produto.configuracaoFiscal) {
      this.produto.configuracaoFiscal.ncm = this.normalizeNcm(this.produto.configuracaoFiscal.ncm);
      this.produto.configuracaoFiscal.cest = this.normalizeCest(this.produto.configuracaoFiscal.cest);
    }

    if(this.produto.cupom){
      this.produto.gerarCupom = true;
      this.cupons = [ this.produto.cupom]
    }

    if(!this.produto.disponibilidade)
      this.produto.disponibilidade = this.disponibilidades[0].id;

    this.novo  =  !this.produto.id;

    for(let i = 0 ; i < this.produto.disponibilidades.length; i++)
      this.produto.disponibilidades[i] =
        this.catalogo.disponibilidades.find((item: any) => item.id ===  this.produto.disponibilidades[i].id)

    if(this.produto.id){
      this.tipoDeProduto = this.produto.tipo;
      this.tagsAlimentar.forEach((tag: any) => {
        tag.selecionada  =  this.produto.tags.find((item: any) => item.id === tag.id) != null
      })
    }
    this.atualizeMapTabsPorId();
    this.carregueVisibilidadePrecosCanais();

    this.setUnidadeProduto();
    if(this.templatesPiza.length){
      this.obtenhaTemplateAdicional('Borda').forEach( (adicionalTemplate: any) => {
          this.adicionalBorda = this.produto.camposAdicionais.find(
            adicional => adicional.template && adicional.template.id === adicionalTemplate.id);

          if(!this.adicionalBorda){
            let adicional = new AdicionalDeProdutoEscolhaSimples(adicionalTemplate.descricao, true);

            adicional.template = adicionalTemplate;

            this.adicionalBorda = adicional;
          }

          adicionalTemplate.opcoes.forEach( opcaoTemplate => {
            let opcaoExistente = this.adicionalBorda.opcoesDisponiveis.find( opcao => opcaoTemplate.id === opcao.template.id)

            if(!opcaoExistente){
              let opcaoAdicional = new OpcaoDeAdicionalDeProduto(opcaoTemplate.nome,
                                            opcaoTemplate.valor, false, opcaoTemplate.descricao, opcaoTemplate);

              opcaoAdicional.codigoPdv = opcaoTemplate.codigoPdv;

              this.adicionalBorda.opcoesDisponiveis.push(opcaoAdicional)
            }

          })

        })

      this.obtenhaTemplateAdicional('Massa').forEach( (adicionalTemplate: any) => {
        this.adicionalMassa = this.produto.camposAdicionais.find(
          adicional => adicional.template && adicional.template.id === adicionalTemplate.id);

        if(!this.adicionalMassa){
          let adicional = new AdicionalDeProdutoEscolhaSimples(adicionalTemplate.descricao, true);

          adicional.template = adicionalTemplate;

          this.adicionalMassa = adicional;
        }

        adicionalTemplate.opcoes.forEach( opcaoTemplate => {
          let opcaoExistente = this.adicionalMassa.opcoesDisponiveis.find( opcao => opcaoTemplate.id === opcao.template.id)

          if(!opcaoExistente){
            let opcaoAdicional = new OpcaoDeAdicionalDeProduto(opcaoTemplate.nome,
              opcaoTemplate.valor, false, opcaoTemplate.descricao, opcaoTemplate);

            opcaoAdicional.codigoPdv = opcaoTemplate.codigoPdv;
            this.adicionalMassa.opcoesDisponiveis.push(opcaoAdicional)
          }

        })
      })

      if(this.produto.id && this.tipoDeProduto === this.TIPOSDEPRODUTOS.Pizza){
        let template: any = this.templatesPiza.find( templatePizza => templatePizza.id === this.produto.template.id);

        template.tamanhos.forEach(( tamanhoTamplate: any) => {
          let  tamanhoProdutoExistente = this.produto.tamanhos.find( tamanhoProduto => tamanhoProduto.template.id === tamanhoTamplate.id);

          if(tamanhoProdutoExistente && tamanhoProdutoExistente.novoPreco)
            tamanhoProdutoExistente.exibirDescontos = true;

          if(!tamanhoProdutoExistente)
            this.produto.tamanhos.push(new ProdutoTamanho(null, 0, tamanhoTamplate, false));
        })

      }

    }

    // exibe os descontos se houver novoPreco ou catalogo for preco por empresa e houver novoPrecoNaEmpresa

    this.exibirDescontos = this.produto.novoPreco != null || (this.catalogo.precoPorEmpresa && this.produto.novoPrecoNaEmpresa != null);

    if(this.temModuloFiscal) {
      if(!this.produto.configuracaoFiscal)
        this.produto.configuracaoFiscal = {};

      if(this.dadosFiscaisCarregados) {
        this.apliqueOrigemFiscalSelecionada();
        this.carregueOpcoesFiscaisDoProdutoAtual();
      }
    }

    this.selecioneTabelaPrecosInicialSeSolicitado();
  }

  carregueComissoes() {
    this.comissionamentoService.listeComissoes().then((comissoes: any[]) => {
      this.comissoes = comissoes || [];
    }).catch((erro) => this.mensagemErro = erro);
  }

  comissaoSelecionada() {
    if(!this.produto?.comissao?.id)
      return null;
    return this.comissoes.find((comissao) => Number(comissao.id) === Number(this.produto.comissao.id)) || this.produto.comissao;
  }

  compareComissao(comissaoA: any, comissaoB: any) {
    return Number(comissaoA?.id || 0) === Number(comissaoB?.id || 0);
  }

  salveComissaoProduto() {
    if(!this.produto?.id || this.salvandoComissaoProduto)
      return;

    delete this.mensagemSucesso;
    delete this.mensagemErro;
    this.salvandoComissaoProduto = true;
    const comissao = this.comissaoSelecionada();
    const catalogoId = this.catalogo?.id || this.produto?.catalogo?.id || null;
    const acao = comissao?.id
      ? this.comissionamentoService.vinculeProdutos(comissao.id, catalogoId, [this.produto.id])
      : this.comissionamentoService.desvinculeProdutos(catalogoId, [this.produto.id]);

    acao.then(() => {
      this.salvou = true;
      this.produto.comissao = comissao || null;
      this.mensagemSucesso = 'Comissão do produto salva com sucesso!';
      this.salvandoComissaoProduto = false;
      setTimeout(() => delete this.mensagemSucesso, 3000);
    }).catch((erro) => {
      this.salvandoComissaoProduto = false;
      this.mensagemErro = erro;
    });
  }

  onNcmChange(value: any) {
    if(!this.produto.configuracaoFiscal)
      this.produto.configuracaoFiscal = {};

    const ncmAnterior = this.normalizeNcm(this.produto.configuracaoFiscal.ncm);
    const novoNcm = this.normalizeNcm(value);

    if(ncmAnterior === novoNcm) {
      this.atualizeNcmSelecionado();
      return;
    }

    this.produto.configuracaoFiscal.ncm = novoNcm;
    if(this.produto.configuracaoFiscal.cest) {
      this.produto.configuracaoFiscal.cest = '';
      this.atualizeCestSelecionado();
    }
    void this.carregueNcms(this.produto.configuracaoFiscal.ncm, true);
    void this.carregueCests('', true);
  }

  onNcmFilterChange(value: string) {
    if(this.ncmSearchTimer) {
      clearTimeout(this.ncmSearchTimer);
    }

    this.ncmSearchTimer = setTimeout(() => {
      void this.carregueNcms(value || '', false);
    }, 200);
  }

  onCestChange(value: any) {
    if(!this.produto.configuracaoFiscal)
      this.produto.configuracaoFiscal = {};

    const cestAnterior = this.normalizeCest(this.produto.configuracaoFiscal.cest);
    const novoCest = this.normalizeCest(value);

    if(cestAnterior === novoCest) {
      this.atualizeCestSelecionado();
      return;
    }

    this.produto.configuracaoFiscal.cest = novoCest;
    this.atualizeCestSelecionado();
    void this.carregueCests(this.produto.configuracaoFiscal.cest, true);
  }

  onCestFilterChange(value: string) {
    if(this.cestSearchTimer) {
      clearTimeout(this.cestSearchTimer);
    }

    this.cestSearchTimer = setTimeout(() => {
      void this.carregueCests(value || '', false);
    }, 200);
  }

  private async carregueNcms(query: string = '', includeSelected: boolean = true) {
    if(!this.temModuloFiscal) {
      return;
    }

    this.ncmLoading = true;

    try {
      const codigoSelecionado = this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm);
      const codigoBusca = this.normalizeDigits(query, 8);
      const textoBusca = codigoBusca ? '' : String(query || '').trim();
      const codigoSelecionadoParaLista = includeSelected ? codigoSelecionado : '';
      const deveBuscarSelecionadoSeparado = includeSelected && codigoSelecionado && codigoBusca !== codigoSelecionado;
      const [opcoes, selecionado] = await Promise.all([
        this.fiscalService.listeNcms(textoBusca, codigoBusca, 80),
        deveBuscarSelecionadoSeparado ? this.carregueNcmPorCodigo(codigoSelecionado) : Promise.resolve(null)
      ]);

      this.ncmOptions = this.mescleNcms(opcoes || [], selecionado, codigoSelecionadoParaLista);
      this.atualizeNcmSelecionado();
    } catch (error) {
      this.ncmOptions = this.mescleNcms([], null, includeSelected ? this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm) : '');
      this.atualizeNcmSelecionado();
    } finally {
      this.ncmLoading = false;
    }
  }

  private async carregueCests(query: string = '', includeSelected: boolean = true) {
    if(!this.temModuloFiscal) {
      return;
    }

    const ncmSelecionado = this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm);
    const codigoSelecionado = this.normalizeCest(this.produto?.configuracaoFiscal?.cest);
    const codigoSelecionadoParaLista = includeSelected ? codigoSelecionado : '';

    if(!/^\d{8}$/.test(ncmSelecionado)) {
      this.cestOptions = this.mescleCests([], null, codigoSelecionadoParaLista);
      this.atualizeCestSelecionado();
      return;
    }

    this.cestLoading = true;

    try {
      const codigoBusca = this.normalizeDigits(query, 7);
      const textoBusca = codigoBusca ? '' : String(query || '').trim();
      const deveBuscarSelecionadoSeparado = includeSelected && codigoSelecionado && codigoBusca !== codigoSelecionado;
      const [opcoes, selecionado] = await Promise.all([
        this.fiscalService.listeCests(ncmSelecionado, textoBusca, codigoBusca, 80),
        deveBuscarSelecionadoSeparado ? this.carregueCestPorCodigo(ncmSelecionado, codigoSelecionado) : Promise.resolve(null)
      ]);

      this.cestOptions = this.mescleCests(opcoes || [], selecionado, codigoSelecionadoParaLista);
      this.atualizeCestSelecionado();
    } catch (error) {
      this.cestOptions = this.mescleCests([], null, codigoSelecionadoParaLista);
      this.atualizeCestSelecionado();
    } finally {
      this.cestLoading = false;
    }
  }

  private async carregueNcmPorCodigo(codigo: string): Promise<any | null> {
    const codigoNormalizado = this.normalizeNcm(codigo);
    if(!codigoNormalizado) {
      return null;
    }

    const itens = await this.fiscalService.listeNcms('', codigoNormalizado, 5);
    return (itens || []).find((item: any) => item?.codigo === codigoNormalizado) || (itens && itens.length ? itens[0] : null);
  }

  private async carregueCestPorCodigo(ncm: string, codigo: string): Promise<any | null> {
    const ncmNormalizado = this.normalizeNcm(ncm);
    const codigoNormalizado = this.normalizeCest(codigo);
    if(!ncmNormalizado || !codigoNormalizado) {
      return null;
    }

    const itens = await this.fiscalService.listeCests(ncmNormalizado, '', codigoNormalizado, 5);
    return (itens || []).find((item: any) => item?.codigo === codigoNormalizado) || (itens && itens.length ? itens[0] : null);
  }

  private mescleNcms(opcoes: any[], selecionado: any, codigoSelecionado: string): any[] {
    const mapa = new Map<string, any>();

    (opcoes || []).forEach((opcao: any) => {
      if(!opcao || !opcao.codigo) return;
      mapa.set(opcao.codigo, this.decorateNcmOption(opcao));
    });

    if(selecionado && selecionado.codigo) {
      mapa.set(selecionado.codigo, this.decorateNcmOption(selecionado));
    }

    if(codigoSelecionado && !mapa.has(codigoSelecionado)) {
      mapa.set(codigoSelecionado, this.decorateNcmOption({
        codigo: codigoSelecionado,
        descricao: 'NCM atual nao encontrado na base local.',
        label: `${codigoSelecionado} - NCM atual nao encontrado na base local.`
      }));
    }

    return Array.from(mapa.values()).sort((a: any, b: any) => a.codigo.localeCompare(b.codigo));
  }

  private atualizeNcmSelecionado() {
    const codigoNormalizado = this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm);
    this.ncmSelecionado = this.ncmOptions.find((item: any) => item.codigo === codigoNormalizado) || null;
  }

  private mescleCests(opcoes: any[], selecionado: any, codigoSelecionado: string): any[] {
    const mapa = new Map<string, any>();

    (opcoes || []).forEach((opcao: any) => {
      if(!opcao || !opcao.codigo) return;
      mapa.set(opcao.codigo, this.decorateCestOption(opcao));
    });

    if(selecionado && selecionado.codigo) {
      mapa.set(selecionado.codigo, this.decorateCestOption(selecionado));
    }

    if(codigoSelecionado && !mapa.has(codigoSelecionado)) {
      mapa.set(codigoSelecionado, this.decorateCestOption({
        codigo: codigoSelecionado,
        descricao: 'CEST atual nao encontrado para o NCM informado.',
        label: `${this.formatCestCode(codigoSelecionado)} - CEST atual nao encontrado para o NCM informado.`
      }));
    }

    return Array.from(mapa.values()).sort((a: any, b: any) => a.codigo.localeCompare(b.codigo));
  }

  private atualizeCestSelecionado() {
    const codigoNormalizado = this.normalizeCest(this.produto?.configuracaoFiscal?.cest);
    this.cestSelecionado = this.cestOptions.find((item: any) => item.codigo === codigoNormalizado) || null;
  }

  private decorateNcmOption(opcao: any): any {
    const descricao = String(opcao?.descricao || '').trim();
    return {
      ...opcao,
      shortLabel: `${opcao.codigo} - ${this.buildNcmTailDescription(descricao)}`,
      tailDescription: this.buildNcmTailDescription(descricao)
    };
  }

  private decorateCestOption(opcao: any): any {
    const descricao = String(opcao?.descricao || '').trim();
    const codigoFormatado = this.formatCestCode(opcao?.codigoFormatado || opcao?.codigo || '');
    return {
      ...opcao,
      codigoFormatado,
      shortLabel: `${codigoFormatado || opcao.codigo} - ${this.buildNcmTailDescription(descricao, 90)}`,
      tailDescription: this.buildNcmTailDescription(descricao, 90)
    };
  }

  private buildNcmTailDescription(descricao: string, maxLength: number = 110): string {
    const texto = String(descricao || '').replace(/\s+/g, ' ').trim();
    if(!texto) {
      return '';
    }

    if(texto.length <= maxLength) {
      return texto;
    }

    const segmentos = texto.split(' / ').map((item) => item.trim()).filter(Boolean);
    if(segmentos.length > 1) {
      let resumo = segmentos[segmentos.length - 1];
      for(let index = segmentos.length - 2; index >= 0; index -= 1) {
        const candidato = `${segmentos[index]} / ${resumo}`;
        if(candidato.length > maxLength - 4) {
          break;
        }
        resumo = candidato;
      }

      if(resumo.length < texto.length) {
        return `... ${resumo}`;
      }
    }

    return `... ${texto.slice(-(maxLength - 4))}`;
  }

  private normalizeNcm(value: any): string {
    return this.normalizeFiscalCode(value, 8);
  }

  private normalizeCest(value: any): string {
    return this.normalizeFiscalCode(value, 7);
  }

  private normalizeFiscalCode(value: any, length: number): string {
    const digits = String(value ?? '').replace(/\D/g, '');
    if(!digits) {
      return '';
    }

    return digits.length < length ? digits.padStart(length, '0') : digits;
  }

  private normalizeDigits(value: any, maxLength: number): string {
    return String(value ?? '').replace(/\D/g, '').slice(0, maxLength);
  }

  private formatCestCode(value: any): string {
    const codigo = this.normalizeCest(value);
    if(codigo.length !== 7) {
      return codigo;
    }

    return `${codigo.slice(0, 2)}.${codigo.slice(2, 5)}.${codigo.slice(5)}`;
  }

  private carregueOpcoesFiscaisDoProdutoAtual() {
    if(!this.temModuloFiscal) {
      return;
    }

    const ncm = this.normalizeNcm(this.produto?.configuracaoFiscal?.ncm);
    const cest = this.normalizeCest(this.produto?.configuracaoFiscal?.cest);

    if(ncm) {
      void this.carregueNcms(ncm, true);
      void this.carregueCests(cest || '', true);
      return;
    }

    this.ncmOptions = [];
    this.ncmSelecionado = null;
    this.cestOptions = [];
    this.cestSelecionado = null;
  }

  private async carregueDadosFiscaisSeNecessario() {
    if(!this.temModuloFiscal || this.dadosFiscaisCarregados || this.carregandoDadosFiscais) {
      return;
    }

    if(!this.produto.configuracaoFiscal)
      this.produto.configuracaoFiscal = {};

    this.carregandoDadosFiscais = true;

    try {
      const [origens, tipos, selos] = await Promise.all([
        this.fiscalService.listeOrigens().catch(() => []),
        this.fiscalService.listeTiposDeTributacaoIPI().catch(() => []),
        this.fiscalService.listeSelosDeControleIPI().catch(() => [])
      ]);

      this.origens = origens;
      this.tiposDeTributacaoIPI = tipos;
      this.selosDeControleIPI = selos;
      this.dadosFiscaisCarregados = true;
      this.apliqueOrigemFiscalSelecionada();
      this.carregueOpcoesFiscaisDoProdutoAtual();
    } finally {
      this.carregandoDadosFiscais = false;
    }
  }

  private apliqueOrigemFiscalSelecionada() {
    if(this.origens && this.produto.configuracaoFiscal && this.produto.configuracaoFiscal.origem)
      for(let i = 0; i < this.origens.length; i++)
        if(this.origens[i].id === this.produto.configuracaoFiscal.origem.id)
          this.produto.configuracaoFiscal.origem = this.origens[i];
  }



  onSalvarProduto() {
    delete this.mensagemErro;
    if(this.frm.valid){
      delete this.mensagemErro;
      this.produto.catalogo = this.catalogo;

      if( this.produto.pesoMinimo && this.produto.valorInicial < this.produto.pesoMinimo ) {
        this.mensagemErro = 'Valor inicial tem que ser maior ou igual ao peso mínimo do produto';
        return;
      }

      if( this.produto.pesoMinimo && this.produto.valorInicial > this.produto.pesoMaximo ) {
        this.mensagemErro = 'Valor inicial tem que ser menor ou igual ao peso máximo do produto';
        return;
      }

      if(!this.empresa || !this.empresa.id)
        delete this.produto.precoNaEmpresa

      this.produtoService.salveProduto(this.produto).then( resposta => {
        this.salvou = true;
        if(!this.produto.id) {
          this.produto.id = resposta.id;
          this.produto.ordem = resposta.ordem;
          this.produto.tamanhos = resposta.tamanhos;
          setTimeout( () => {
            if(this.produto.tipo === this.TIPOSDEPRODUTOS.Pizza){
              this.selecioneTabMassas();
            } else {
              this.selecioneTabAdicionais();
            }
          }, 0);
        }

        this.produto.nome = resposta.nome;
        this.produto.descricao = resposta.descricao;

        this.frm.form.markAsPristine();
        this.frm.form.markAsUntouched();
        this.mensagemSucesso = 'Produto salvo com sucesso!'
        setTimeout ( () => {
          delete this.mensagemSucesso ;
        }, 3000);
      }).catch( erro => {
        this.mensagemErro   = erro;
      })
    }
  }

  salveImagensProduto(fnRetorno: Function) {
    if(!this.podeEditarProdutos) {
      this.mensagemErro = 'As imagens do produto são controladas pelo catálogo da rede. Solicite a edição ao responsável pelo catálogo da rede.';
      fnRetorno(this.mensagemErro);
      return;
    }

    this.produtoService.salveImagensProduto(this.catalogo, this.produto).then( resposta => {
      this.salvou = true;
      fnRetorno( );
    }).catch( erro => {
      fnRetorno(erro);
    })
  }

  onSalvarPontosFidelidade(){
    delete this.mensagemErro;
    if(this.frmf.valid && !this.salvando){
      this.salvando = true;
      this.produtoService.salvePontosProduto(this.produto).then( resposta => {
        this.salvou = true;
        this.mensagemSucesso = 'Pontos fidelidade salvo com sucesso!'
        this.salvando = false;
        this.frmf.form.markAsPristine();
        this.frmf.form.markAsUntouched();
        setTimeout ( () => {
          delete this.mensagemSucesso ;
        }, 3000);
      }).catch( erro => {
        this.salvando = false;
        this.mensagemErro   = erro;
      })
    }
  }

  onSalvarDisponibilidade(){
    delete this.mensagemErro;
    const erroConsumo = this.telaInsumoAssociado?.valideConfiguracaoConsumo();
    if(erroConsumo){
      this.mensagemErro = erroConsumo;
      return;
    }
    if(!this.empresa || !this.empresa.id)
      delete this.produto.disponibilidadeNaEmpresa

    if(!this.salvando){
      this.produto.disponibilidades = this.viewDisponibilidades.disponibilidades;
      this.salvando = true;

      if(this.telaInsumoAssociado)
        this.telaInsumoAssociado.setInsumoDesvinculado();

      this.produtoService.salveDisponibilidadeProduto(this.catalogo, this.produto).then( resposta => {
        this.salvou = true;
        this.mensagemSucesso = 'Produto salvo com sucesso!'
        this.salvando = false;
        this.telaInsumoAssociado.salvou();

        setTimeout ( () => {
          delete this.mensagemSucesso ;
        }, 3000);
      }).catch( erro => {
        this.salvando = false;
        this.mensagemErro   = erro;
      })
    }
  }

  salveClassificacao(){
    delete this.mensagemErro;

    let tags = this.tagsAlimentar.filter((item: any) => item.selecionada);

    this.salvando = true;
    this.produtoService.salveTagsProdutos(this.catalogo, this.produto,  tags).then(resposta => {
      this.salvou = true;
      this.mensagemSucesso = 'Produto salvo com sucesso!'
      this.salvando = false;
      setTimeout ( () => {
        delete this.mensagemSucesso ;
      }, 3000);
    }).catch( erro => {
      this.salvando = false;
      this.mensagemErro   = erro;
    })

  }

  novoAdicional() {
    this.abrirDialogAdicional = true;
  }

  editarAdicional($event: EditEvent) {
    this.abrirDialogAdicional  = true;
    setTimeout( () => {
      this.cadAdicionalProduto.exibaAdicional($event.dataItem)
    })
  }

  carregue($event: PageChangeEvent) {   }

  encerrouEdicaoDeAdicional(adicionalDeProduto: any) {
    this.abrirDialogAdicional = false;
  }

  removerAdicional($event: RemoveEvent) {
    this.adicionalRemover = $event.dataItem
    this.adicionalRemoverIndex = $event.rowIndex
    this.abraDialogoRemover = true;
  }

  exibaCopiarAdicionalProduto() {
    this.copiarAdicional = true;
  }

  copiouAdicionais(novosAdicionais: any) {
    this.copiarAdicional = null;
    if(novosAdicionais && novosAdicionais.length)
      novosAdicionais.forEach( adicional => this.produto.camposAdicionais.push(adicional))
  }

  obtenhaFormato() {
    if(!this.produto.unidadeMedida) return '0.00'

    return String(`0.00 ${this.produto.unidadeMedida.sigla}`);
  }

  obtenhaFormatoPreco(){
    if(!this.produto.tipoDeVenda || this.produto.tipoDeVenda !== 'Peso')
      return '$0.00'

    return String(`$ 0.00/ kg`);
  }

  obtenhaFormatoPercentual(){
    return String(`0.0"%"`);
  }

  alterouUnidade(){  }

  alterouValorUnidade(){
    this.setValoresPadroes();
  }

  setValoresPadroes(){
    if(this.produto.unidadeMedida){
      if(!this.produto.valorInicial)
        this.produto.valorInicial = this.produto.unidadeMedida.valorInicialPadrao;
      if(!this.produto.incremento)
        this.produto.incremento =  this.produto.unidadeMedida.incrementoPadrao;
    }
  }

  fecheModal() {

    super.fecheModal( { recarregar: this.salvou} )
  }

  escolheuTemplate(tipoTemplate, template = null) {
    this.tipoDeProduto = tipoTemplate;
    this.atualizeMapTabsPorId();
    if(this.tipoDeProduto === this.TIPOSDEPRODUTOS.Pizza){
      let pizza = new ProdutoPizza();

      pizza.template = template

      pizza.template.tamanhos.forEach( (tamanhoTamplate) => {
        pizza.tamanhos.push(new ProdutoTamanho(null, 0, tamanhoTamplate));
      })

      this.setProduto(pizza)

    }
  }

  obtenhaClassTamanho(tamanho: any) {
    if(tamanho.qtdePedacos  <= 6) return 'x1'
    if(tamanho.qtdePedacos  <= 8) return 'x2'
    if(tamanho.qtdePedacos  <= 10) return 'x3'

    return 'x4'

  }

  obtenhaImagemTamanho(tamanho: any){
    if(tamanho.qtdePedacos  <= 6) return 'pizza-pequena.png'
    if(tamanho.qtdePedacos  <= 8) return 'pizza-media.png'
    if(tamanho.qtdePedacos  <= 10) return 'pizza-grande.png'

    return 'pizza-familia.png'
  }

  obtenhaClassCor(tamanho: any){
    if(!tamanho || !tamanho.template.disponivel) return 'light'

    if(tamanho.qtdePedacos  <= 6) return 'info '
    if(tamanho.qtdePedacos  <= 8) return 'success'
    if(tamanho.qtdePedacos  <= 10) return 'warning'

    return 'primary'
  }

  obtenhaTemplateAdicional(descricao: string) {
    if(!this.produto.template) return [];

    let template: any = this.templatesPiza.find( templatePizza => templatePizza.id === this.produto.template.id);

    return template ? template.adicionais.filter(
      adicional =>   adicional.descricao.toLowerCase() === descricao.toLowerCase())
       : []
  }

  limpeMensagens() {

    this.mensagemErro = null;
    this.mensagemSucesso = null;
  }

  onTabSelect(event: any) {
    this.limpeMensagens();

    if(event?.title === 'Fiscal') {
      void this.carregueDadosFiscaisSeNecessario();
    }
  }

  selecioneTabAdicionais(){
    const index = this.mapTabsPorId['adicionais'];

    this.tabSet.selectTab(index);
  }

  selecioneTabTabelaPrecos(tamanho?: any){
    const index = this.mapTabsPorId['tabelaPrecos'];

    if(index == null || !this.produto?.id) return;

    if(tamanho?.id)
      this.tabelaPrecosTargetKey = `PRODUTO_TAMANHO:${Number(tamanho.id)}`;

    this.tabSet.selectTab(index);
  }

  selecioneTabMassas(){
      const index = this.mapTabsPorId['massas'];

    this.tabSet.selectTab(index)
  }

  selecioneTabDisponibilidade(){
    const index = this.mapTabsPorId['disponibilidade'];

    this.tabSet.selectTab(index);
  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  private atualizeMapTabsPorId() {
    const deslocamentoTabelaPrecos = this.exibirTabelaPrecosSeparada ? 1 : 0;
    const deslocamentoPrecosCanais = this.exibirPrecosCanais ? 1 : 0;
    const deslocamentoComissionamento = this.temModuloComissionamento ? 1 : 0;

    if(this.tipoDeProduto === this.TIPOSDEPRODUTOS.Pizza) {
      this.mapTabsPorId = {
        'detalhes': 0,
        'tabelaPrecos': this.temModuloTabelaPrecos ? 1 : null,
        'precosCanais': this.exibirPrecosCanais ? 1 + deslocamentoTabelaPrecos : null,
        'comissoes': this.temModuloComissionamento ? 1 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais : null,
        'massas': 1 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
        'bordas': 2 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
        'adicionais': 3 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
        'disponibilidade': 4 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
        'historico': 5 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento
      };
      return;
    }

    this.mapTabsPorId = {
      'detalhes': 0,
      'tabelaPrecos': this.temModuloTabelaPrecos ? 1 : null,
      'precosCanais': this.exibirPrecosCanais ? 1 + deslocamentoTabelaPrecos : null,
      'comissoes': this.temModuloComissionamento ? 1 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais : null,
      'adicionais': 1 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
      'disponibilidade': 2 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento,
      'historico': 3 + deslocamentoTabelaPrecos + deslocamentoPrecosCanais + deslocamentoComissionamento
    };
  }

  private carregueVisibilidadePrecosCanais(): void {
    const produtoId = Number(this.produto?.id);
    if(!this.empresa?.id || !produtoId || produtoId === this.ultimoProdutoIdPrecosCanais) return;
    this.ultimoProdutoIdPrecosCanais = produtoId;
    this.canaisVendaFacade.listeCanaisProduto(produtoId).then(linhas => {
      if(Number(this.produto?.id) !== produtoId) return;
      this.exibirPrecosCanais = linhas.some(({canal, produto}) =>
        canal.ativo && (!produto.preco.herdaBase || canal.percentualPrecoPadrao != null));
      this.atualizeMapTabsPorId();
    }).catch(() => {
      if(Number(this.produto?.id) !== produtoId) return;
      // Deixe a aba acessível para que o erro e a opção de tentar novamente sejam exibidos nela.
      this.exibirPrecosCanais = true;
      this.atualizeMapTabsPorId();
    });
  }

  private selecioneTabelaPrecosInicialSeSolicitado() {
    if(!this.abrirTabelaPrecosAoCarregar || !this.temModuloTabelaPrecos || !this.produto?.id) return;

    setTimeout(() => this.selecioneTabTabelaPrecos(), 0);
  }

  get precoCardapioCanais(): number | null {
    const preco = this.catalogo?.precoPorEmpresa && this.empresa?.id
      ? (this.produto?.precoNaEmpresa ?? this.produto?.preco) : this.produto?.preco;
    return preco == null ? null : Number(preco);
  }

  get descontoCardapioCanais(): number {
    const novoPreco = this.catalogo?.precoPorEmpresa && this.empresa?.id
      ? (this.produto?.novoPrecoNaEmpresa ?? this.produto?.novoPreco) : this.produto?.novoPreco;
    const preco = this.precoCardapioCanais;
    return novoPreco == null || preco == null ? 0
      : Math.max(0, Math.round((preco - Number(novoPreco)) * 100) / 100);
  }

  get disponivelCardapioCanais(): boolean {
    const disponibilidade = this.exibirDisponibilidadeEmpresa()
      ? (this.produto?.disponibilidadeNaEmpresa ?? this.produto?.disponibilidade) : this.produto?.disponibilidade;
    return Number(disponibilidade) !== 2 && this.produto?.disponivelParaDelivery !== false;
  }

  handleFilter(value) {

    this.categorias = this.catalogo.categorias.filter((categoria) => categoria.nome.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleFilterCupom(value) {

  }

  salvarAdicional(adicional: any, frm: NgForm) {
    this.limpeMensagens();

    if(!frm.valid ||  adicional.salvando)
      return;

    adicional.salvando = true;

    this.produtoService.salveAdicional(this.catalogo, this.produto, adicional, this.empresa.id ? null : true).then( (resp) => {
      this.salvou = true;
      if(!adicional.id)  adicional.id = resp.id;
      adicional.opcoesDisponiveis = resp.opcoesDisponiveis;
      adicional.salvando = false;
      this.mensagemSucesso = String(`${adicional.nome}s salvo com sucesso!`);
      frm.form.markAsPristine();
      frm.form.markAsUntouched();
    }).catch((erro) => {
      adicional.salvando = false;
      this.mensagemErro = erro;
    })


  }

  exibaDescontos(){
    this.exibirDescontos = true;
  }

  removerDesconto(){
    this.exibirDescontos = false;
    this.frm.form.markAsDirty();

    if(this.podeEditarProdutos) {
      delete  this.produto.percentualDesconto;
      delete   this.produto.novoPreco;
    }
    else if(this.podeEditarPrecos) {
      delete this.produto.percentualDescontoNaEmpresa;
      delete this.produto.novoPrecoNaEmpresa;

    }
    this.produto.destaque = false;
  }

  alterouNovoPreco() {
    this.produto.percentualDesconto =  Number((  100 - (this.produto.novoPreco / this.produto.preco ) * 100 ).toFixed(2))
  }

  alterouNovoPrecoNaEmpresa() {
    this.produto.percentualDescontoNaEmpresa =  Number((  100 - (this.produto.novoPrecoNaEmpresa /
      this.produto.precoNaEmpresa ) * 100 ).toFixed(2))
  }


  alterouPercentualDesconto() {
    let desconto =  this.produto.preco *   (this.produto.percentualDesconto / 100 );
    this.produto.novoPreco = Number(this.produto.preco - desconto).toFixed(2);
  }

  alterouPercentualDescontoNaEmpresa() {
    let desconto =  this.produto.precoNaEmpresa *   (this.produto.percentualDescontoNaEmpresa / 100 );
    this.produto.novoPrecoNaEmpresa = Number(this.produto.precoNaEmpresa - desconto).toFixed(2);
  }

  alterouNovoPrecoTamanho(tamanho: any){
    tamanho.percentualDesconto =  Number((  100 - (tamanho.novoPreco / tamanho.preco ) * 100 ).toFixed(2))
  }

  alterouPercentualDescontoTamanho(tamanho: any){
    let desconto =  tamanho.preco *   (tamanho.percentualDesconto / 100 );
    tamanho.novoPreco = Number(tamanho.preco - desconto).toFixed(2);

  }

  removerDescontoTamanho(tamanho: any){
    tamanho.exibirDescontos = false;
    delete  tamanho.percentualDesconto;
    delete tamanho.novoPreco
   tamanho.destaque = false;
    this.frm.form.markAsDirty();
  }

  adicionarImagem() {
    if(!this.produto.imagensAdicionais)
      this.produto.imagensAdicionais = []

    this.produto.imagensAdicionais.push({indice: this.produto.imagensAdicionais.length + 2})
  }

  salveImagemAdicional($event: any, imagemAdicional: any) { }


  excluirAdicional(turno: any) {
    if(turno.id){
      turno.removido = true;
    } else {
      this.produto.turnos.splice( this.produto.turnos.indexOf(turno), 1);
    }
  }

  exibirNoSite(){
    return this.temModuloFidelidade && !this.temModuloPedidos
  }

  integradoComEcletica() {
    return this.empresa.integracaoDelivery && this.empresa.integracaoDelivery.sistema === 'ecletica';
  }
  integradoComEcleticaOuGCOM() {
    return this.empresa.integracaoDelivery && (this.empresa.integracaoDelivery.sistema === 'ecletica' ||
      this.empresa.integracaoDelivery.sistema === 'gcom');
  }

  trendsFoods(){
    return this.empresa && this.empresa.rede === 'chinainbox'
  }

  pontuarFidelidade() {
    if(this.modoProdutosExternos)
      return false;

    if(!this.empresa || !this.empresa.integracaoPedidoFidelidade)
      return false;

    let tipoAcumulo = this.empresa.integracaoPedidoFidelidade.plano.tipoDePontuacao.tipo;

    return tipoAcumulo === 'qtde-variavel-por-atividade' || tipoAcumulo === 'cashback'
  }

  acumulaReais(){
    if(!this.empresa || !this.empresa.integracaoPedidoFidelidade)
      return false;

    return this.empresa.integracaoPedidoFidelidade.plano.tipoDeAcumulo === 'Reais';
  }

  getCashbackExibir(atividade){
    if(atividade.cashback)
      return String(`${(atividade.cashback * 100).toFixed(1)}%`);

  }

  exibirDisponibilidadeEmpresa() {
    if(!this.catalogo ||  !this.empresa) return false;

    return this.catalogo.disponibilidadePorEmpresa  && this.empresa.id
  }

  getIconTag(nome: string){
    return nome.toLowerCase().replace(' ', '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  onSalvarFiscal(frmFiscal: NgForm) {
    delete this.mensagemErro;
    delete this.mensagemSucesso;

    if(!frmFiscal.valid) {
      this.mensagemErro = 'Informe a origem nas configurações fiscais do produto.';
      return;
    }
    this.fiscalService.salveConfiguracoesFiscais(this.produto, this.produto.configuracaoFiscal).then( () => {
      this.mensagemSucesso = 'Configurações fiscais salvas com sucesso!'
      setTimeout ( () => {
        delete this.mensagemSucesso ;
      }, 3000);

    }).catch( erro => {
      this.mensagemErro = erro;
    });

  }

  setProdutoBrinde(){
   this.tipoDeProduto =  this.produto.tipo = this.TIPOSDEPRODUTOS.BrindeFidelidade;

  }

  ehBrindeFidelidade(){
    return  this.produto.tipo === this.TIPOSDEPRODUTOS.BrindeFidelidade;
  }

  // Otimiza detecção de mudanças em listas
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  carregueCupons() {
    if(!this.produto.gerarCupom)
      this.produto.cupom = null

    if(!this.cupons.length){
      this.cuponsService.listeCupons({}).then((cupons: any) => {
        this.cupons = cupons;
      })
    }
  }
}
